import { useEffect, useRef } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

interface MathProps {
  children: string;
  block?: boolean;
  className?: string;
}

export function Math({ children, block = false, className = "" }: MathProps) {
  const spanRef = useRef<HTMLSpanElement>(null);
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const containerRef = block ? divRef : spanRef;
    if (containerRef.current) {
      try {
        katex.render(children, containerRef.current, {
          displayMode: block,
          throwOnError: false,
          strict: false,
        });
      } catch (error) {
        console.error("KaTeX rendering error:", error);
        if (containerRef.current) {
          containerRef.current.textContent = children;
        }
      }
    }
  }, [children, block]);

  if (block) {
    return <div ref={divRef} className={`my-4 text-center ${className}`} />;
  }

  return <span ref={spanRef} className={className} />;
}
